import { unauthorizedFeaturesOverride } from 'constants/general';
import { WidgetFeature } from 'enums/WidgetFeature';
import { DefaultRootState } from 'react-redux';

export const selectFeatureEnabled = <T = number | boolean>(
    state: DefaultRootState,
    feature: WidgetFeature,
) => {
    if (!state) {
        return false;
    }

    let enabled = state.features[feature];

    if (state.features.LimitUnauthorizedFeatures) {
        const { parameters } = state;
        const { getTokensData, getClientDataJws, adAuthUrl } = parameters;

        const isAuthUsed = Boolean(getTokensData || getClientDataJws || adAuthUrl);
        const override = unauthorizedFeaturesOverride[feature];

        if (!isAuthUsed && override != null) {
            enabled = override;
        }
    }

    return enabled as unknown as T;
};
